import EntryActionTypes from '../constants/EntryActionTypes';

const createUserRoleAssignment = (data) => ({
  type: EntryActionTypes.USER_ROLE_ASSIGNMENT_CREATE,
  payload: {
    data,
  },
});

const createUserRoleAssignmentInCurrentBoard = (data) => ({
  type: EntryActionTypes.USER_ROLE_ASSIGNMENT_IN_CURRENT_BOARD_CREATE,
  payload: {
    data,
  },
});

const updateUserRoleAssignment = (id, data) => ({
  type: EntryActionTypes.USER_ROLE_ASSIGNMENT_UPDATE,
  payload: {
    id,
    data,
  },
});

const deleteUserRoleAssignment = (id) => ({
  type: EntryActionTypes.USER_ROLE_ASSIGNMENT_DELETE,
  payload: {
    id,
  },
});

const handleUserRoleAssignmentCreate = (assignment) => ({
  type: EntryActionTypes.USER_ROLE_ASSIGNMENT_CREATE_HANDLE,
  payload: {
    assignment,
  },
});

const handleUserRoleAssignmentUpdate = (assignment) => ({
  type: EntryActionTypes.USER_ROLE_ASSIGNMENT_UPDATE_HANDLE,
  payload: {
    assignment,
  },
});

const handleUserRoleAssignmentDelete = (assignment) => ({
  type: EntryActionTypes.USER_ROLE_ASSIGNMENT_DELETE_HANDLE,
  payload: {
    assignment,
  },
});

export default {
  createUserRoleAssignment,
  createUserRoleAssignmentInCurrentBoard,
  updateUserRoleAssignment,
  deleteUserRoleAssignment,
  handleUserRoleAssignmentCreate,
  handleUserRoleAssignmentUpdate,
  handleUserRoleAssignmentDelete,
};
